import { useEffect, useState } from 'react';
import { getVods } from '../api/rttsClient';
import { useStudioAuth } from './useStudioAuth';
import { STUDIO_HOME_PATH, STUDIO_LANDING_PATH } from '../studioLinks';
import { isGameEligibleVod } from '../utils/vodEligibility';

/**
 * Home rail target: landing when logged-in with zero eligible Twitch VODs.
 * Logged-out and users with VODs stay on `/studio`.
 */
export function useStudioHomePath(): string {
  const { status, isLoggedOut } = useStudioAuth();
  const [homePath, setHomePath] = useState(STUDIO_HOME_PATH);

  useEffect(() => {
    if (isLoggedOut || status !== 'linked') {
      setHomePath(STUDIO_HOME_PATH);
      return;
    }
    let cancelled = false;
    void getVods()
      .then((vods) => {
        if (cancelled) return;
        setHomePath(
          vods.some(isGameEligibleVod) ? STUDIO_HOME_PATH : STUDIO_LANDING_PATH
        );
      })
      .catch(() => {
        if (!cancelled) setHomePath(STUDIO_HOME_PATH);
      });
    return () => {
      cancelled = true;
    };
  }, [isLoggedOut, status]);

  return homePath;
}
